import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import chapterService from '../../services/chapter.service';

export const getChapterList = createAsyncThunk('chapterSlice/getPageDetails', async (params, thunkAPI) => {
  try {
    const data = await chapterService.getChaptersAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const addChapter = createAsyncThunk('chapterSlice/addChapter', async (params, thunkAPI) => {
  try {
    const data = await chapterService.addChapterAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateChapter = createAsyncThunk('chapterSlice/updateChapter', async (params, thunkAPI) => {
  try {
    const data = await chapterService.updateChapterAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const deleteChapter = createAsyncThunk('chapterSlice/deleteChapter', async (params, thunkAPI) => {
  try {
    const data = await chapterService.deleteChapterAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateChapterStatus = createAsyncThunk('chapterSlice/updateChapterStatus', async (params, thunkAPI) => {
  try {
    const data = await chapterService.updateChapterStatusAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getStaticPages = createAsyncThunk('chapterSlice/getStaticPages', async (thunkAPI) => {
  try {
    const data = await chapterService.getStaticPagesAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const addStaticPage = createAsyncThunk('chapterSlice/addStaticPage', async (params, thunkAPI) => {
  try {
    const data = await chapterService.addStaticPageAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateStaticPage = createAsyncThunk('chapterSlice/updateStaticPage', async (params, thunkAPI) => {
  try {
    const data = await chapterService.updateStaticPageAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const detailStaticPage = createAsyncThunk('chapterSlice/detailStaticPage', async (params, thunkAPI) => {
  try {
    const data = await chapterService.detailStaticPageAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  chapterList: [],
  staticList: []
};

const chapterSlice = createSlice({
  name: 'chapterSlice',
  initialState,
  extraReducers: {
    [getChapterList.fulfilled]: (state, action) => {
      state.chapterList = action.payload.data;
    },
    [getStaticPages.fulfilled]: (state, action) => {
      console.log(action.payload.data);
      state.staticList = action.payload.data;
    }
  }
});

const { reducer } = chapterSlice;
export default reducer;
